import React from "react";
import { Button, Text, Tooltip } from "@showitinc/showit-wc";

import { createFormFieldFromSelection } from "@/utils/PropertyUtils";
import uiPrefix from "@/utils/UiPrefixUtils";
import UserActions from "@/actions/UserActions";
import { TRACK_SOURCE_TOOLBAR } from "@/constants/AnalyticsConstants.mjs";

import styles from "../ElementToolbar.module.css";

/**
 * Toolbar action that turns a selected legacy text form field into a modern input.
 * @param {Object} props
 * @param {Immutable.Map} props.selectedElements - The block's selected elements, by id.
 * @returns {JSX.Element}
 */
const PotentialFormFieldToolbarButtons = ({ selectedElements }) => {
  const handleConvert = () => {
    UserActions.trackPostHogEvent("convert_to_form_field_clicked", {
      source: TRACK_SOURCE_TOOLBAR,
    });
    createFormFieldFromSelection(selectedElements, TRACK_SOURCE_TOOLBAR);
  };

  return (
    <Tooltip delay={10} position="top-center" positionType="absolute">
      <Button
        variant="icon"
        data-e2e={uiPrefix("convert-to-form-field-btn")}
        data-testid="convert-to-form-field-btn"
        className={styles.button}
        onClick={handleConvert}
        iconPrefix="formFieldText"
        iconSize="20"
      />
      <span slot="content">
        <Text className={styles.label}>Convert to Form Field</Text>
      </span>
    </Tooltip>
  );
};

export default PotentialFormFieldToolbarButtons;
